import type { PlanLegDeploy, PlanLegDeployState } from '@developerz/domain';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { StatusPill, type StatusTone } from './StatusPill';

// Where one leg's merge is live (plan 101 slice 12): one chip per environment the projection
// reports (`PlanProjectionGroup.deploy`, the domain's `planLegDeploys`), sorted by name on
// the server. The state is in WORDS ("production: Pending"), so the chip never leans on its
// hue alone. Presenter, shared by the epic view's slice row and the breakdown table.
//
// TONE: `pending` is the one live state — the leg merged and a deploy there is owed now — so
// it alone takes the accent; `deployed` is settled success, `failed` danger, and `unknown`
// (no merge commit to join a verdict on, or a verdict that was neither) neutral.

const DEPLOY_TONE: Record<PlanLegDeployState, StatusTone> = {
  deployed: 'success',
  failed: 'danger',
  pending: 'live',
  unknown: 'neutral',
};

const DEPLOY_LABEL: Record<PlanLegDeployState, string> = {
  deployed: 'fleet.epic.deploy.state.deployed',
  failed: 'fleet.epic.deploy.state.failed',
  pending: 'fleet.epic.deploy.state.pending',
  unknown: 'fleet.epic.deploy.state.unknown',
};

export function PlanLegDeployChips(props: {
  readonly deploy: readonly PlanLegDeploy[];
}): JSX.Element {
  return (
    <span class="plan-leg-deploy">
      <For each={props.deploy}>
        {(d) => (
          <StatusPill tone={DEPLOY_TONE[d.state]}>
            {t('fleet.epic.deploy.chip', {
              environment: d.environment,
              state: t(DEPLOY_LABEL[d.state]),
            })}
          </StatusPill>
        )}
      </For>
    </span>
  );
}
